import { PaymentMethodSetupFooter } from '../components/payment-method-setup/footer/footer';
import { PaymentMethodSetupForm } from '../components/payment-method-setup/form/form';
import type { PaymentMethodSetupProviderProps } from './payment-method-setup/context/payment-method-setup-base.context';
import { PaymentMethodSetupProvider } from './payment-method-setup/context/payment-method-setup.context';

export type PaymentMethodSetupProps = PaymentMethodSetupProviderProps;

/**
 * ```tsx
 * <PaymentMethodSetup kind='card' api={api} session={session} gatewayConfig={config} setupKey={key} onSaved={...} onCancel={...}>
 *   <PaymentMethodSetup.Form />
 *   <PaymentMethodSetup.Footer />
 * </PaymentMethodSetup>
 * ```
 */
const PaymentMethodSetup: PaymentMethodSetupNamespace = (props: PaymentMethodSetupProps) => (
  <PaymentMethodSetupProvider {...props} />
);

type PaymentMethodSetupNamespace = React.FC<PaymentMethodSetupProps> & {
  Form: typeof PaymentMethodSetupForm;
  Footer: typeof PaymentMethodSetupFooter;
};

PaymentMethodSetup.Form = PaymentMethodSetupForm;
PaymentMethodSetup.Footer = PaymentMethodSetupFooter;

export { PaymentMethodSetup };
